import React from "react"

const VehicleCollectionImportantNotes: React.FC = () => {
  return (
    <div className="rounded-lg bg-gray-50 p-6">
      <h4 className="mb-3 font-semibold">Important Notes:</h4>
      <ul className="space-y-2 text-sm text-gray-700">
        <li className="flex items-start">
          <span className="mr-3 mt-2 h-2 w-2 flex-shrink-0 rounded-full bg-honeycomb"></span>
          Please arrive 15 minutes before your scheduled time
        </li>
        <li className="flex items-start">
          <span className="mr-3 mt-2 h-2 w-2 flex-shrink-0 rounded-full bg-honeycomb"></span>
          Bring your driving license
        </li>
        <li className="flex items-start">
          <span className="mr-3 mt-2 h-2 w-2 flex-shrink-0 rounded-full bg-honeycomb"></span>
          Vehicle inspection will take approximately 30 minutes
        </li>
        <li className="flex items-start">
          <span className="mr-3 mt-2 h-2 w-2 flex-shrink-0 rounded-full bg-honeycomb"></span>
          You'll receive your vehicle keys and documentation
        </li>
      </ul>
    </div>
  )
}

export default VehicleCollectionImportantNotes
